import { useOneClick } from 'contexts/OneClickBuyContext';
import { formatCardNumber, formatExpiration, NewCardField } from 'helpers/newCard';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ICARUS_CONTAINER_ID } from 'services/CardTokenizer';
import { onlyNumbers } from 'utils/currency';
import { Container, ErrorText, Field, Fields } from './styles';

interface FieldConfig {
	field: NewCardField;
	autoComplete: string;
	inputMode?: 'numeric' | 'text';
	placeholder?: string;
	wide?: boolean;
	format?: (value: string) => string;
}

const FIELDS: FieldConfig[] = [
	{ field: 'number', autoComplete: 'cc-number', inputMode: 'numeric', wide: true, format: formatCardNumber },
	{ field: 'holder', autoComplete: 'cc-name', wide: true },
	{ field: 'expiration', autoComplete: 'cc-exp', inputMode: 'numeric', placeholder: 'MM/AA', format: formatExpiration },
	{
		field: 'securityCode',
		autoComplete: 'cc-csc',
		inputMode: 'numeric',
		format: value => onlyNumbers(value).slice(0, 4),
	},
	{ field: 'document', autoComplete: 'off', inputMode: 'numeric', wide: true, format: value => onlyNumbers(value).slice(0, 14) },
];

const NewCardForm: React.FC = () => {
	const { isNewCardRequired, newCardFields, setNewCardField, newCardErrors } = useOneClick();
	const { t } = useTranslation('upsell');

	if (!isNewCardRequired) return null;

	return (
		<Container>
			<p>{String(t('newCard.title'))}</p>
			<Fields>
				{FIELDS.map(({ field, autoComplete, inputMode = 'text', placeholder, wide, format }) => (
					<Field key={field} $wide={wide} $invalid={newCardErrors.includes(field)}>
						<label htmlFor={`ticto-new-card-${field}`}>{String(t(`newCard.${field}`))}</label>
						<input
							id={`ticto-new-card-${field}`}
							name={field}
							autoComplete={autoComplete}
							inputMode={inputMode}
							placeholder={placeholder}
							aria-invalid={newCardErrors.includes(field)}
							value={newCardFields[field]}
							onChange={event => setNewCardField(field, format ? format(event.target.value) : event.target.value)}
						/>
					</Field>
				))}
			</Fields>
			{newCardErrors.length > 0 && <ErrorText role='alert'>{String(t('newCard.invalid'))}</ErrorText>}
			<div id={ICARUS_CONTAINER_ID} />
		</Container>
	);
};

export default NewCardForm;
